import { render } from "./DateRangePicker.vue?vue&type=template&id=456454c8"
import script from "./DateRangePicker?vue&type=script&lang=js&external"
export * from "./DateRangePicker?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__